import { useState, useEffect } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    TextField,
    Button,
    ToggleButton,
    ToggleButtonGroup,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Stack,
    FormHelperText,
    CircularProgress,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@mui/material";
import { apiHandler, ErrLoaderOff } from "@shared/Functions/apiHandler";
import { validateEmpty, validateMinLength } from "@shared/Validations/validations";
import { commonServices } from "../../Services/commonServices";
import LatlogModel from "./latlogModel";


const InputField = ({ value, setValue, errors, title, placeholder, id }) => {
    const theme = useTheme();
    const classes = pageStyles(theme);
    return (
        <Box sx={{ my: 1 }}>
            <InputLabel sx={classes.darkTextSmall}> {title} </InputLabel>
            <TextField
                size="small"
                fullWidth
                required
                id={id}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                error={errors}
                helperText={errors}
                sx={classes.inputField}
                placeholder={placeholder}
            />
        </Box>)
}

export default function AddressDrawer({ open = false, setOpen, selectedAddress }) {
    const theme = useTheme();
    const classes = pageStyles(theme);

    const [addressType, setAddressType] = useState("Home");
    const [label, setLabel] = useState("");
    const [line1, setLine1] = useState("");
    const [line2, setLine2] = useState("");
    const [landmark, setLandmark] = useState("");
    const [postal, setPostal] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState(1);
    const [state, setState] = useState("");
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [errors, setErrors] = useState({});
    const [editStatus, setEditStatus] = useState(false);
    const [loader, setLoader] = useState(false);

    function validate() {
        const e = {};
        e.line1 = validateEmpty(line1, "Address Line 1", "line1") || validateMinLength(line1, "Address Line 1", 5);
        e.postal = validateEmpty(postal, "Postal Code", "postal") || validateMinLength(postal, "Postal Code", 6);
        e.city = validateEmpty(city, "City", "city");
        e.country = validateEmpty(country, "Country");
        e.state = validateEmpty(state, "State");

        if (!location) {
            e.location = "Please select location";
        }

        const hasErrors = Object.values(e).some((err) => err);
        console.log(hasErrors, "hasErrors");
        setErrors(e);
        if (hasErrors) {
            return false;
        }
        else {
            editStatus ? editAddress() : AddAddress();
        }
    }

    const AddAddress = async () => {
        let data = {
            "type": addressType === "Home" ? 1 : addressType === "Office" ? 2 : 3,  //1-home,2-office,3-other
            "lineOne": line1,
            "lineTwo": line2,
            "landmark": landmark,
            "postalCode": postal,
            "city": city,
            "countryId": country,
            "stateId": state,
            "name": addressType === "Other" ? label : addressType,
            "lat": location.lat,
            "long": location.lng,
        }
        console.log(data, "data");
        setLoader(true);
        const res = await commonServices.addAddress(data);
        apiHandler(res, classes.successToast, true);
        ErrLoaderOff(res, setLoader);
        if (res?.status === 200) {
            handleOff();
        }
    }

    const editAddress = async () => {
        let data = {
            "type": addressType === "Home" ? 1 : addressType === "Office" ? 2 : 3,  //1-home,2-office,3-other
            "lineOne": line1,
            "lineTwo": line2,
            "landmark": landmark,
            "postalCode": postal.toString(),
            "city": city,
            "countryId": country,
            "stateId": state,
            "name": addressType === "Other" ? label : addressType,
            "addressId": selectedAddress?.id,
            "lat": location.lat,
            "long": location.lng,
        }
        setLoader(true);
        const res = await commonServices.editAddress(data);
        apiHandler(res, classes.successToast, true);
        ErrLoaderOff(res, setLoader);
        if (res?.status === 200) {
            handleOff();
        }
    }

    const handleOff = () => {
        setTimeout(() => {
            setLoader(false);
            handleClose();
        }, 1000)
    }

    const handleSave = () => {
        validate();

    }

    const getCountries = async () => {
        const res = await commonServices.getCountries();
        apiHandler(res);
        if (res?.status === 200) {
            setCountries(res?.data?.data?.countryDetails);
        }
    }

    const getCities = async () => {
        let payload = {
            "countryId": country
        }
        const res = await commonServices.getCities(payload);
        apiHandler(res);
        if (res?.status === 200) {
            setStates(res?.data?.data?.countryDetails);
        }
    }

    const dataSetter = () => {
        if (selectedAddress?.name) {
            console.log(selectedAddress, "selectedAddress");
            setAddressType(selectedAddress?.type === 1 ? "Home" : selectedAddress?.type === 2 ? "Office" : "Other");
            setLabel(selectedAddress?.name);
            setLine1(selectedAddress?.lineOne);
            setLine2(selectedAddress?.lineTwo);
            setLandmark(selectedAddress?.landmark);
            setPostal(selectedAddress?.postalCode);
            setCity(selectedAddress?.city);
            setCountry(selectedAddress?.countryId);
            setState(selectedAddress?.stateId);
            setLocation({ lat: selectedAddress?.location?.coordinates[0], lng: selectedAddress?.location?.coordinates[1] });
            setEditStatus(true);
        }
    }

    const [latopen, setLatOpen] = useState(false);
    const [location, setLocation] = useState(null);

    const handleSelect = (coords) => {
        console.log("Selected Coordinates:", coords);
        setLocation(coords);
    };

    useEffect(() => {
        getCountries();
        getCities();
        dataSetter();
    }, [selectedAddress]);

    function handleClose() {
        setLocation(null);
        setErrors({});
        setOpen(false);
        setLabel('');
        setLine1('');
        setLine2('');
        setLandmark('');
        setPostal('');
    }

    return (
        <Drawer anchor="right" open={open} onClose={handleClose}
            slotProps={{
                paper: {
                    sx: { width: { xs: '100%', sm: 400 }, p: 3 }
                }
            }}>

            <LatlogModel
                open={latopen}
                onClose={() => setLatOpen(false)}
                onSelect={handleSelect}
            />


            <Box sx={classes.flex_center_btn} mb={1}>
                <Typography variant="h6">Add New Address </Typography>
                <IconButton onClick={handleClose} aria-label="close drawer">
                    <CloseIcon />
                </IconButton>
            </Box>

            <Divider />

            <Stack>
                <Box my={1}>
                    <Typography variant="subtitle2">
                        Address Type
                    </Typography>
                    <ToggleButtonGroup
                        value={addressType}
                        exclusive
                        onChange={(e, val) => val && setAddressType(val)}
                        aria-label="address type"
                        size="small"
                    >
                        {["Home", "Office", "Other"].map((type) => (
                            <ToggleButton
                                key={type}
                                value={type}
                                sx={classes.toogleBtn}
                            >
                                {type}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </Box>

                {addressType === "Other" &&
                    <TextField
                        label="Enter Custom Label"
                        size="small"
                        fullWidth
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}

                    />}

                <InputField
                    value={line1}
                    setValue={setLine1}
                    errors={errors.line1}
                    title="Address Line 1"
                    placeholder="House/Flat Number, Street Name"
                    id="line1"
                />

                <InputField
                    value={line2}
                    setValue={setLine2}
                    errors={errors.line2}
                    title="Address Line 2 (Optional)"
                    placeholder="Area, Colony, District"
                />

                <InputField
                    value={landmark}
                    setValue={setLandmark}
                    errors={errors.landmark}
                    title="Landmark (Optional)"
                    placeholder="Near famous landmark"
                />

                <InputField
                    value={postal}
                    setValue={setPostal}
                    errors={errors.postal}
                    title="Postal Code"
                    placeholder="Postal Code"
                    id="postal"
                />

                <InputField
                    value={city}
                    setValue={setCity}
                    errors={errors.city}
                    title="City"
                    placeholder="Enter City Name"
                    id="city"
                />

                <Box sx={{ my: 1 }}>
                    <InputLabel sx={classes.darkTextSmall}> Country </InputLabel>
                    <FormControl size="small" fullWidth error={!!errors.country} placeholder="Select Country">
                        <Select
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            sx={classes.inputField}
                            placeholder="Select Country"
                        >
                            {countries?.map((country) => (
                                <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                            ))}
                        </Select>
                        {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
                    </FormControl>
                </Box>

                <Box sx={{ my: 1 }}>
                    <InputLabel sx={classes.darkTextSmall}> State </InputLabel>
                    <FormControl size="small" fullWidth >
                        <Select
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            disabled={!country}
                            sx={classes.inputField}
                        >
                            {states?.map((state) => (
                                <MenuItem key={state.id} value={state.id}>{state.name}</MenuItem>
                            ))}

                        </Select>
                        {errors.state && <FormHelperText sx={{ color: theme.palette.error.main }}>{errors.state}</FormHelperText>}
                    </FormControl>
                </Box>

                <InputLabel sx={classes.darkTextSmall}> Location </InputLabel>
                <Button
                    onClick={() => setLatOpen(true)}
                    variant="contained"
                    fullWidth
                >
                    {location ? "Change Location" : "Click Here to Select Location"}

                </Button>
                {location && (
                    <Box sx={classes.darkTextSmall}>
                        Lat: {location.lat},
                        Lng: {location.lng}
                    </Box>
                )}

                <Typography sx={classes.errorText}>
                    {errors.location}
                </Typography>

                <Box sx={classes.deliveryIns}>
                    <b>Delivery instructions:</b> Our delivery partners will contact you on the provided phone number when they arrive at your location.
                </Box>

                <Box sx={classes.flex_c}>
                    <Button
                        startIcon={!loader && <SaveIcon />}
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        size="large"
                        disabled={loader}
                    >
                        {loader ? <CircularProgress size={20} /> : "Save Address"}
                    </Button>
                </Box>

            </Stack>
        </Drawer>
    );
}


